/* has_device_changed.icon.svg.js */

module.exports = {
    icon: `           
            <svg viewBox="0 0 24 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M16.5,0.5C12.4,0.5,9,3.8,9,8s3.4,7.5,7.5,7.5c4.2,0,7.5-3.4,7.5-7.5S20.7,0.5,16.5,0.5z M17.4,13h-1.8v-1.8
                    h1.8V13z M19,8.7c-0.4,0.4-1,0.8-1.6,0.9v0.6h-1.8V8.8V7.9h0.9c0.5,0,0.9-0.2,1.2-0.5c0.3-0.3,0.5-0.7,0.5-1.2S18,5.3,17.7,5
                    c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.7-0.5,1.2H13c0-1,0.4-1.9,1-2.5c0.6-0.6,1.5-1,2.5-1
                    c1,0,1.9,0.4,2.5,1c0.6,0.6,1,1.5,1,2.5S19.7,8,19,8.7z"/>
                <g>
                    <path class="foreground-gl" d="M8,0c1.3,0,2.6,0.3,3.7,0.9c-0.3,0.2-0.7,0.4-1,0.6C9.9,1.1,9,0.9,8,0.9C4.1,0.9,0.9,4.1,0.9,8
                        s3.2,7.1,7.1,7.1c1,0,1.9-0.2,2.7-0.5c0.3,0.2,0.6,0.4,1,0.6C10.6,15.7,9.3,16,8,16c-4.4,0-8-3.6-8-8C0,3.6,3.6,0,8,0z"/>
                </g>
            </g>
            </svg>
        `
};
